import type { User } from "../types"

export default function getUserFromLocalStorage(): User | false {
	if (
		localStorage.getItem("jamUser") &&
		localStorage.getItem("jamUser") !== "undefined"
	) {
		return JSON.parse(localStorage.getItem("jamUser") || "")
	} else return false
}
